import { Box, Card, CardActionArea, CardActions, CardContent, CardMedia, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { features, useAppContext } from '../contexts/AppContext';
import { Feature } from '../types';
import Grid from '@mui/material/Grid2';

const Home = () => {
  const { setNewRole } = useAppContext();
  const navigate = useNavigate();
  return (
    <>
      <Box
        sx={{
          borderRadius: '10px',
          margin: 0,
          p: 2,
          height: '100vh',
          display: 'flex',
          backgroundImage: 'URL(/smt-bg.png)',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
        }}
      >
        <Box
          sx={{
            borderRadius: '10px',
            p: 0,
            margin: 'auto',
            maxWidth: 1000,
            flexGrow: 1,
          }}
        >
          <Grid container spacing={2}>
            {features.map((item: Feature) => (
              <Grid
                sx={{
                  borderRadius: '10px',
                  p: 0,
                  margin: 'auto',
                  maxWidth: 1200,
                  flexGrow: 1,
                }}
                size={{ sm: 6 }}
              >
                <Card>
                  <CardActionArea
                    onClick={() => {
                      setNewRole(item.role);
                      navigate(item.path);
                    }}
                  >
                    <CardMedia sx={{ height: 250 }} image={'/' + item.img} title={item.name}></CardMedia>
                    <CardContent>
                      <Typography gutterBottom variant="h5" component="div">
                        {item?.name}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {item?.description}
                      </Typography>
                    </CardContent>
                    <CardActions></CardActions>
                  </CardActionArea>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Box>
    </>
  );
};

export default Home;
